<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            @click="closeModal('modal-send-print')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-member" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Add Member
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="memberData.email" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required (Please enter a valid ALI email address)
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="addMember()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            @click="closeModal('modal-add-member')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-edit-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Edit Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Team Name</label>
                <input v-model="team_name" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>

              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Monthly Target Group Referral</label>
                <input v-model="team_target_referrals" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="editTeam()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            @click="closeModal('modal-edit-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>

    <div class="row dvQuickGlance forTeams">

      <div class="col s12 l7 row valign-wrapper dvQuickGlance-main">
        <!-- :class="{ l8: $getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole, l7: $getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole }" -->
        <div
          class="col s12 dvQuickGlance-info valign-wrapper">
          <ImageUploader
            :photo="team.photo"
            @replacePhoto="replacePhoto"></ImageUploader>
          <div class="dvQuickGlance-user">
            <div class="dvQuickGlance-user-channel"><span class="icon-fs_world"></span>{{ team.channel }}</div>
            <div class="dvQuickGlance-user-team">{{ team.team }}</div>
            <div class="dvQuickGlance-user-details">
              <div class="dvQuickGlance-user-details-label">Team name:</div>
              {{ team.team_name }}
            </div>
            <div class="dvQuickGlance-user-details">
              <div class="dvQuickGlance-user-details-label">Manager:</div>
              {{ team.manager }}
            </div>
          </div> <!-- dvQuickGlance-user -->
        </div> <!-- dvQuickGlance-info -->

        <div
          v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
          class="col dvQuickGlance-action">
          <a v-if="team.manager_email" :href="'mailto:'+team.manager_email" class="waves-effect waves-light btn-RoundCorners"><span class="icon-action_check_circle"></span><div class="label">contact manager</div></a>
        </div> <!-- dvQuickGlance-action -->

        <div
          v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
          class="col dvQuickGlance-action">

          <router-link
            :to="{ name:'team_member_resolve', params: { id: 'all', referral_id: 'all' } }"
            class="waves-effect waves-light btn-RoundCorners">
            <span class="icon-action_check_circle"></span><div class="label">Resolve All</div>
          </router-link>

          <a
            ref="tippy_main_menu"
            name="main-menu"
            class="waves-effect waves-dark btn-Menu-more flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

          <tippy
           to="main-menu"
           placement="bottom-end"
           offset="[10, 0]"
           interactive
           arrow
           trigger="click">
           <div class="morePopMenuBox-content ">
             <!-- <a
              @click="openModalTeam('modal-add-member')"
              href="javascript:void(0)" class="morePopMenuBox-content-item">
               <span class="icon-action_add"></span>Add Member
             </a> -->
             <a
              @click="openModalTeam('modal-edit-team')"
              href="javascript:void(0)" class="morePopMenuBox-content-item">
               <span class="icon-action_edit"></span>Edit Team
             </a>
           </div>
         </tippy>


        </div> <!-- dvQuickGlance-action -->

      </div> <!-- dvQuickGlance-main -->

      <div class="col s12 l5 dvQuickGlance-links">
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Valid<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgValid flexCenterAll">{{ summary.valid }}</div>
        </div> <!-- dvQuickGlance-link -->
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Pending<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgPending flexCenterAll">{{ summary.pending }}</div>
        </div> <!-- dvQuickGlance-link -->
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Expiring<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgExpiring flexCenterAll">{{ summary.expiring }}</div>
        </div> <!-- dvQuickGlance-link -->
      </div>
    </div> <!-- dvQuickGlance -->

    <div class="row dvContent forTeams">

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_referrals"></span>Team Members ({{ pager.totalRecords }})
          </div> <!-- dvSectionTitleOpts-title -->
          <div class="dvSectionTitleOpts-options">
            <!-- <div class="waves-effect waves-light btn-Pill">
              <span class="icon-editor_list"></span>
              <div class="label">List</div>
            </div> -->
            <!-- <a
              id="show-add-member"
              v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
              href="#modal-add-member" class="waves-effect waves-light btn-RoundCorners modal-trigger"><span class="icon-action_add_circle"></span><div class="label">Add Member</div></a> -->
            <a
              id="show-edit-team"
              v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
              href="#modal-edit-team" class="waves-effect waves-light btn-RoundCorners modal-trigger"><span class="icon-action_edit"></span><div class="label">Edit Team</div></a>

          </div> <!-- dvSectionTitleOpts-options -->
        </div> <!-- dvSectionTitleOpts -->

        <div class="dvCards-container">
          <div class="row">
            <div
              v-show="noRecordFound && !loading"
              class="col s12 dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                  <div class="dvBlankSection-text-primary center-align">
                    There are no team members to display
                  </div>
                  <div class="dvBlankSection-text-secondary center-align">
                    Try using the search box above to find what you are looking for.
                  </div>
                </div>
              </div>
            </div>

            <ContentLoader :loading="membersLoading" :firstLoad="firstLoad" v-if="true"></ContentLoader>

            <!-- <div
              v-show="membersLoading"
              class="col s12 dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-text-primary center-align">
                    Please wait...
                  </div>
                </div>
              </div>
            </div> -->

            <div
              v-for="(member, index) in members" :key="index"
              class="col s12 m12 l6 xl4">
              <div class="dvCardClient">
                <div class="dvCardClient-header">
                  <div class="dvCardClient-header-name">

                    <div class="dvCardProfile-image">
                      <div class="dvCardProfile-image-placer flexCenterAll"><div><span class="icon-fs_user"></span></div></div>
                      <img class="dvCardProfile-image-pic responsive-img" :src="member.photo" v-show="member.photo && member.photo.length > 0"/>
                    </div>

                    <div class="dvCardClient-header-name-info">
                      {{ $store.getters.formatFullName(member.first_name, member.last_name) || member.email }}
                      <div class="dvCardClient-header-name-info-label">{{ member.position }}</div>
                    </div> <!-- dvCardClient-header-name-info -->
                  </div> <!-- dvCardClient-header-name -->

                  <div
                    v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                    class="dvCardClient-header-menu">

                    <a
                      :name="'card-box-menu-'+index"
                      :ref="'tippy_menu'+index"
                      class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

                    <tippy
                     v-bind:to="'card-box-menu-'+index"
                     placement="bottom-end"
                     offset="[10, 2]"
                     interactive
                     arrow
                     trigger="click">
                     <div class="morePopMenuBox-content ">

                       <router-link
                         class="morePopMenuBox-content-item"
                         :to="{ name:'team_member', params: { id: member.id, status: 'valid' } }">
                         <span class="icon-editor_view"></span>View
                       </router-link>

                       <router-link
                        v-if="member.pending > 0"
                         class="morePopMenuBox-content-item"
                         :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: 'all' } }">
                         <span class="icon-action_check"></span>Resolve
                       </router-link>

                       <!-- <a
                       @click="confirm({
                         id: member.id,
                         type: 'remove-member'
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <span class="icon-action_delete"></span>Remove
                       </a> -->

                     </div>
                   </tippy>

                  </div> <!-- dvCardClient-header-menu -->
                </div> <!-- dvCardClient-header -->
                <div class="dvCardClient-content">
                  <div class="dvCardClient-content-items">
                    <div
                      v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                      disabled class="waves-effect waves-light dvCardClient-content-items-link">
                      <div>Valid</div>
                      <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                    </div> <!-- dvCardClient-content-items-link -->
                    <div
                      v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                      disabled class="waves-effect waves-light dvCardClient-content-items-link">
                      <div>Pending</div>
                      <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                    </div> <!-- dvCardClient-content-items-link -->
                    <div
                      v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                      disabled class="waves-effect waves-light dvCardClient-content-items-link">
                      <div>Expiring</div>
                      <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                    </div> <!-- dvCardClient-content-items-link -->


                    <router-link
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'team_member', params: { id: member.id, status: 'valid' } }">
                      <div>Valid</div>
                      <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                    </router-link>

                    <router-link
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'team_member', params: { id: member.id, status: 'pending' } }">
                      <div>Pending</div>
                      <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                    </router-link>

                    <router-link
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'team_member', params: { id: member.id, status: 'expiring' } }">
                      <div>Expiring</div>
                      <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                    </router-link>

                    <div
                      v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                      class="dvCardClient-content-items-label"><span class="icon-content_activity"></span>{{ member.last_activity }}</div>
                  </div> <!-- dvCardClient-content-items -->

                  <div
                    v-if="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole"
                    class="row dvCardClient-content-action">
                    <div class="col s12">
                      <a
                        :disabled="userDetails.id == member.id"
                        :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                    </div> <!-- col -->
                  </div> <!-- dvCardClient-content-action -->
                  <div
                    v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole"
                    class="row dvCardClient-content-action">
                    <div class="col s12 m6">
                      <div
                        v-if="member.pending == 0"
                        class="waves-effect waves-light btn-RoundCorners isResolve isDisabled">
                        <div class="label">Resolve</div>
                      </div>
                      <router-link
                        v-if="member.pending > 0"
                        :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: 'all' } }"
                        href="javascript:void(0)"
                        class="waves-effect waves-light btn-RoundCorners isResolve">
                        <div class="label">Resolve</div>
                        <div class="dvCardClient-count">{{ member.pending }}</div>
                      </router-link> <!-- RoundCorners -->
                    </div> <!-- col -->
                    <div class="col s12 m6">
                      <a
                        :disabled="userDetails.id == member.id"
                        :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                    </div> <!-- col -->
                  </div> <!-- dvCardClient-content-action -->
                </div> <!-- dvCardClient-content -->
              </div> <!-- dvCardClient -->
            </div> <!-- col -->

          </div> <!-- row -->
        </div>
      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <a
            :disabled="(pager.currentPage < 2 || loading) ? true : false"
            @click="previousPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            <span class="icon-nav_chevron_left"></span>Previous
          </a>
<!--  -->
          <div class="dvContentTools-pagination">
            <form id="frmChangePassword" @submit.prevent="setPage">
              <input
                type="text" class="browser-default" v-model="pager.currentPage" />
            </form>
            <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
            <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
          </div>

          <a
            :disabled="!pager.hasNext || loading"
            @click="nextPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            Next<span class="icon-nav_chevron_right"></span>
          </a>
        </div>
        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>
  </div>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import M from 'materialize-css'
  import ImageUploader from '@/components/TeamImageUploader.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import printJS from 'print-js'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'teams-main',
    data: () => ({
      printSendTo: '',
      sendingPrint: false,
      loadedCnt: 0,
      firstLoad: true,
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      memberData: {
        email: ''
      },
      team_name: '',
      team_target_referrals: '',
      team: {},
      summary: {
        valid: '0',
        pending: '0',
        expiring: '0'
      },
      members: [],
      pager: {
        currentPage: 1,
        perPage: 9,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      userDetails: {},
      sortPopMenuBox: '',
      orderBy: '',
      loading: false,
      noRecordFound: false,
      membersLoading: false,
      saving: false,
      domain: '',
    }),
    watch: {
      loadedCnt: function() {
        if(this.loadedCnt == 2){
          this.firstLoad = false
        }
      },
      refreshImport (newPage, oldPage) {

        let allowedPages = [ 'teams' ]
        let res = newPage.split(':');
        if(allowedPages.indexOf(res[0]) >= 0){
          this.getTeamDetails()
          this.getMembers()
        }
      }
    },
    computed: {
      refreshImport  (){
        return this.$store.getters.getRefreshPage();
      }
    },
    methods: {
      printJS (){
        printJS(this.domain+'/api/teams?request_type=print');
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = '/api/teams?request_type=mail&send_to='+this.printSendTo
        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      replacePhoto (photo){
        this.team.photo = photo
      },
      editTeam (){

        if(this.team_name == ''){
          this.showMessage('The team name field is required.', 'sb-failed')
          return false
        }

        if(this.team_target_referrals == ''){
          this.showMessage('The monthly target group referral field is required.', 'sb-failed')
          return false
        }

        if(this.saving){
          return false
        }

        let self = this
        self.saving = true
        let teamUpdate = {
          team_name: this.team_name,
          team_target_referrals: this.team_target_referrals
        }

        this.$http.secured.put('api/teams/'+this.team.id, teamUpdate)
          .then(response => {
            this.team_name = response.data.team_name
            this.team_target_referrals = response.data.team_target_referrals
            this.team.team_name = this.team_name
            this.team.team_target_referrals = this.team_target_referrals

            this.closeModal('modal-edit-team')
            this.showMessage('Team successfully updated', 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      addMember (){

        if(this.memberData.email == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.saving){
          return false
        }

        let self = this
        self.saving = true

        this.$http.secured.post('api/members', this.memberData)
          .then(response => {
            this.closeModal('modal-add-member')
            this.showMessage('Member has been successfully registered. Email sent to ' + response.data.email, 'sb-success')
            this.memberData.email = ''
            this.getMembers()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        let team_name = this.team.team_name
        this.team_name = team_name

        let team_target_referrals = this.team.team_target_referrals
        this.team_target_referrals = team_target_referrals

        this.memberData.email = ''
        this.printSendTo = ''
      },
      openModalTeam (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'remove-member'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to remove this?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_delete',
            positionBtn: 'Remove',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }

      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'remove-member'){
          this.processRemoveMember(this.dialog.id)
        }
      },
      processRemoveMember (id){
        this.$http.secured.delete('api/members/'+ id)
          .then(response => {
            this.showMessage('Member has been successfully deleted', 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      setPage (){
        if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
          this.pager.currentPage = 1
        }

        this.getMembers();
      },
      previousPage (){
        this.pager.currentPage--;
        this.getMembers();
      },
      nextPage (){
        this.pager.currentPage++;
        this.getMembers();
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      getMembers () {
        if(this.membersLoading){
          return false;
        }

        window.scroll(0, 0)

        let self = this
        this.membersLoading = true
        this.noRecordFound = false
        this.selected = [];
        this.members = [];
        let url = '/api/members?page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        this.$http.plain.get(url)
          .then(response => {

            this.members = response.data.members;

            if(this.members.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.membersLoading = false
            self.loadedCnt++
          })
      },
      getTeamDetails () {
        if(this.loading){
          return false;
        }

        let self = this
        this.loading = true
        let url = 'api/teams'

        this.$http.plain.get(url)
          .then(response => {
            this.team = response.data.team
            this.summary = response.data.summary

            let team_name = this.team.team_name
            let team_target_referrals = this.team.team_target_referrals
            this.team_name = team_name
            this.team_target_referrals = team_target_referrals

          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
      }
    },
    mounted() {
      this.domain = this.$store.getters.getApiURL
      this.userDetails = this.$store.getters.getCurrentUserDetails
      this.getTeamDetails()
      this.getMembers()
      M.AutoInit()
      if(this.$route.query.removed){
        this.showMessage(this.$route.query.msg, 'sb-success')
      }
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      ImageUploader,
      BodyLoader,
      ContentLoader,
      ToTop
    }
  }
</script>
